import React, { useEffect, useCallback, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getFileCommande,
  getDetailCommande,
  getCommandeById,
  updateCmd
} from "../../Redux/commandeReduce";
import { fetchProduit, fetchProduitAfc } from "../../Redux/produitReduce";
import { verification } from "../../Redux/usersReduce";
import Configuration from "../../configuration";
import { t } from "react-multi-lang";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";

function UpdateCmd({ obj, client }) {
  const dispatch = useDispatch();
  const location = useParams();
  var idCmd = location.id;
  var id = location.id;
  var token = localStorage.getItem("x-access-token");
  const saveTableCalled = useRef(false);
  const [save, setSave] = useState(false);
  const [resteZero, setResteZero] = useState(0);
  const [entitiesReste, setEntitiesReste] = useState([]);
  const [alert, setAlert] = useState(null);
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  //Produit
  const [total, setTotal] = useState(0);
  const [produitSelect, setProduitSelect] = React.useState([]);
  const [optionProduit, setOptionProduit] = React.useState([
    {
      value: "",
      label: "Produit",
      isDisabled: true,
    },
  ]);

  //input
  const [fileURL, setFileURL] = React.useState(null);
  const [fileName, setFileName] = React.useState("");
  const [ext, setExt] = React.useState("");
  const [data, setData] = React.useState([]);
  const [cmd, setCmd] = React.useState({});
  const [loader, setLoader] = React.useState(true);

  const idRole = useRef(0);
  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };
  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      setIdRole(response.payload.id_role)
    }
  }, [dispatch]);

  const setTable = useCallback(async (table, init) => {
    var arrayBody = [];
    if (init === 0) {
      table.forEach((value, index) => {
        let reste = 0;
        const coefUC = parseInt(value.produits.Coefficient_UC);
        let quantiteFix = value.quantite_fix;
        const remise = (1 - (parseFloat(value.Remise) || 0) / 100);


        if (quantiteFix < coefUC) {
          const seuil = 0.6 * coefUC;
          if (quantiteFix >= seuil && value.tag == 2) {
            // Arrondir au carton supérieur
            quantiteFix = coefUC;
          }
          reste = coefUC - quantiteFix;
        } else if ((quantiteFix % coefUC) > 0) {
          const modulo = quantiteFix % coefUC;
          const seuil = 0.6 * coefUC;
          if (modulo >= seuil) {
            quantiteFix += coefUC - modulo; // Arrondir au carton supérieur
          }
          reste = coefUC - (quantiteFix % coefUC);
          if (reste === coefUC) reste = 0;
        }


        arrayBody.push({
          index: index,
          designation: value.produits.Designation_1,
          quantite_non_soldee: value.quantite_non_soldee,
          quantite: value.produits.commerce == 1 ? value.quantite : 0,
          quantite_fix: value.produits.commerce == 1 ? quantiteFix : 0,
          code_pct: value.produits.Code_PCT,
          code_article: value.produits.Code_article,
          prix: value.prix,
          tag: value.produits.tag,
          Remise: value.Remise,
          total: value.produits.commerce == 1
            ? quantiteFix
              ? parseFloat(value.prix * quantiteFix * remise).toFixed(3)
              : 0
            : 0,
          idProduit: value.produits.id,
          reste: value.produits.commerce == 1 ? reste : 0,
          nb: value.produits.commerce == 1 ? quantiteFix ? parseInt(quantiteFix / coefUC) : 0 : 0,
          cartonnage: value.produits.commerce == 1 ? coefUC : 0,
          commerce: value.produits.commerce,
        });
      });
      setData(arrayBody);


    } else {
      table.forEach((value, index) => {

        arrayBody.push({
          designation: value.designation,
          quantite: value.quantite,
          quantite_fix: value.quantite_fix,
          code_pct: value.code_pct,
          code_article: value.code_article,
          quantite_non_soldee: value.quantite_non_soldee,
          prix: value.prix,
          tag: value.tag,
          Remise: value.Remise,
          total: parseFloat(value.total).toFixed(3),
          idProduit: value.idProduit,
          reste: value.reste,
          nb: value.nb,
          cartonnage: value.cartonnage,
          index: index,
          commerce: value.commerce,
        });
      });
      setData(arrayBody);
    }
    calculateTotalSum(arrayBody)
  }, []);

  const getproduit = useCallback(async () => {
    var type = await dispatch(fetchProduit({ client }));
    var data = type.payload;
    var arrayOption = [];
    var obj2 = {};
    console.log(obj)
    data.forEach((e) => {
      arrayOption.push({
        value: e.id, label: e.Designation_1, code_article: e.Code_article, code_pct: e.Code_PCT, prix: e.Prix, reste: null, cartonnage: e.Coefficient_UC, commerce: e.commerce, tag: e.tag, Remise:
          e.Remise === 1
            ? client == "/medis"
              ? obj.user.remise_industrie2
              : obj.user.remise_industrie3
            : 0
      });
      obj2[e.id] = e;
    });
    setOptionProduit(arrayOption);
  }, [dispatch]);

  const getproduitAfc = useCallback(async (client) => {
    var type = await dispatch(fetchProduitAfc({ client }));
    var data = type.payload;
    var arrayOption = [];
    var obj2 = {};
    data.forEach((e) => {
      arrayOption.push({
        value: e.id, label: e.Code_article + ":" + e.Designation_1, code_article: e.Code_article, code_pct: e.Code_PCT, prix: e.Prix, reste: null, cartonnage: e.Coefficient_UC, commerce: e.commerce, tag: e.tag, Remise: e.Remise === 1
          ? client == "/medis"
            ? obj.user.remise_industrie2
            : obj.user.remise_industrie3
          : 0
      });
      obj2[e.id] = e;
    });
    setOptionProduit(arrayOption);
  }, [dispatch]);

  const removeProduit = useCallback(
    async (list, select, id) => {
      var list2 = [...list]
      list[id].idProduit = null;
      list[id].designation = null;
      list[id].reste = null;
      list[id].cartonnage = null;
      list[id].nb = null;
      list[id].commerce = null;
      list[id].quantite_non_soldee = 0;
      list[id].Remise = 0;
      list[id].tag = 0;
      select[id] = null;
      setProduitSelect(select);
      setData(list);
      setTable(list, 1);
    },
    [setTable]
  );

  // ajouter nouveau ligne data
  function AjoutLigne(event) {
    var list = [];
    if (data.length > 0) list = [...data];
    list[list.length] = {
      index: list.length,
      designation: null,
      quantite: 0,
      quantite_fix: 0,
      prix: 0,
      total: 0,
      reste: null,
      cartonnage: 0,
      quantite_non_soldee: 0,
      nb: 0,
      tag: 0,
      Remise: 0,
      code_pct: null,
      code_article: null,
      idProduit: null,
      commerce: null,
    };
    setData(list);
  }

  // Effacer les lignes
  function deleteLigne(nb) {
    if (data.length > 1) {
      var list1 = [...produitSelect];
      list1.splice(parseInt(nb), 1);
      setProduitSelect(list1);
      var filtered = data.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });
      calculateTotalSum(filtered)
      setData(filtered);
      notify(1, t("supprimer_succes"));
    } else {
      notify(2, t("contient_ligne"));
    }
  }
  /* detailCmd */
  const detailCmd = useCallback(async (idCmd) => {
    var det = await dispatch(getDetailCommande(idCmd));
    var dataD = await det.payload;
    setTable(dataD, 0);
    var dataCmd = await dispatch(getCommandeById(idCmd));
    var cmdD = await dataCmd.payload;
    setCmd(cmdD);
  }, [dispatch, idCmd]);

  const getFileCmdFromDB = React.useCallback(
    async (file) => {
      var fileLocal = localStorage.getItem("file");
      setFileName(fileLocal);
      var splitFile = fileLocal.split(".");
      var ext1 = splitFile[splitFile.length - 1];
      setExt(ext1);
      dispatch(getFileCommande(file)).then(async (e1) => {
        setLoader(false);
        var ff = null;
        if (ext1 === "pdf") {
          ff = new Blob([e1.payload], {
            type: "application/pdf",
          });
        } else {
          ff = new Blob([e1.payload], {
            type: "application/*",
          });
        }
        const f = URL.createObjectURL(ff);
        setFileURL(f);
      });
    },
    [dispatch]
  );

  const saveTable = useCallback(
    async (entities, idCmd, total) => {
      var verif = true;
      var verifReste = true;

      var ligneMsg = []

      if (entities.length > 0) {
        entities.forEach((data) => {
          if (data.idProduit === null) {
            verif = false;
            if (!ligneMsg.includes(data.index + 1)) {
              ligneMsg.push(data.index + 1); // Add index to ligneMsg
            }
          }
        });
        entities.forEach((data) => {
          if (data.commerce == 1 && (data.quantite == 0 || data.quantite == "" || data.quantite == null || isNaN(data.quantite))) {
            verif = false;
            if (!ligneMsg.includes(data.index + 1)) {
              ligneMsg.push(data.index + 1); // Add index to ligneMsg
            }
          }
        });

        entities.forEach((data) => {
          if ((data.tag == 1) && data.reste > 0) verifReste = false;
        });

        entities.forEach((data) => {
          if (data.commerce == 1 && (data.quantite_fix == 0 || data.quantite_fix == "" || data.quantite_fix == null || isNaN(data.quantite_fix))) {
            verif = false;
            if (!ligneMsg.includes(data.index + 1)) {
              ligneMsg.push(data.index + 1); // Add index to ligneMsg
            }
          }
        });
      } else {

        verif = false;
      }
      if (verifReste == false) {
        notify(2, "Le produit n’est recommandable que par multiple de carton");
        return
      }
      if (verif === false) {
        if (ligneMsg.length > 0) notify(2, "Vérifier les lignes : " + ligneMsg.join(" ,"));
        else notify(2, t("erreur"));
      } else {
        if (saveTableCalled.current) return;
        saveTableCalled.current = true
        setSave(true)
        dispatch(updateCmd({ Montant: total, ligne: entities, idCmd: idCmd })).then((e) => {
          if (e.payload === true) {
            notify(1, t("update_txt"));
            setTimeout(() => {
              window.location.replace(client + "/commandeList")
            }, 800);
          } else {
            saveTableCalled.current = false
            setSave(false)
            notify(2, t("erreur"));
          }
        });
      }
    },
    [dispatch]
  );


  const confirmMessageProduit = (entities, produitSelect, rowIndex, v) => {
    var e = [...entities];
    const index = e.findIndex(item => item.idProduit === v.value);
    var select = [...produitSelect];
    select[rowIndex] = null
    setProduitSelect(select);
    if (index !== -1) {

      setAlert(
        <SweetAlert
          title=""
          style={{ display: "block", marginTop: "-100px" }}
          success
          onConfirm={() => idRole.current == 5 ? confirmProduitAfc(entities, produitSelect, rowIndex, v) : confirmProduit(entities, produitSelect, rowIndex, v)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("yes")}
          cancelBtnText={t("no")}
          showCancel
        >
          <h3 className="alert-title">{t("valider_produit")}</h3>
          {t("valider_produit_msg")}?
        </SweetAlert>
      );
    } else {
      confirmProduit(entities, produitSelect, rowIndex, v)
    }
  };
  const hideAlert = () => {
    setAlert(null);
  };

  const confirmProduit = useCallback(
    async (entities, produitSelect, rowIndex, v) => {
      hideAlert()
      var e = [...entities];
      var select = [...produitSelect];
      e[rowIndex].idProduit = v.value;
      e[rowIndex].designation = v.label;
      e[rowIndex].code = v.code;
      e[rowIndex].code_article = v.code_article;
      e[rowIndex].prix = v.prix;
      e[rowIndex].id_site = v.id_site;
      e[rowIndex].commerce = v.commerce;
      e[rowIndex].tag = v.tag;
      e[rowIndex].cartonnage = v.cartonnage;
      e[rowIndex].Remise = v.Remise;
      let quantite = parseInt(e[rowIndex].quantite) || 0;
      let remiseDecimal = 0;
      if (e[rowIndex].Remise && e[rowIndex].Remise !== 0) {
        remiseDecimal =
          typeof e[rowIndex].Remise === "number"
            ? e[rowIndex].Remise
            : parseFloat(e[rowIndex].Remise);
        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
      }

      if (v.cartonnage > 0 && quantite / v.cartonnage >= 0.6 && v.tag == 2) {
        quantite = Math.ceil(quantite / v.cartonnage) * v.cartonnage;

        const seuil = v.cartonnage * 0.6;
        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
      }

      e[rowIndex].quantite = quantite;
      e[rowIndex].nb = v.cartonnage > 0 && quantite ? parseInt(quantite / v.cartonnage) : 0;

      if (quantite && quantite < v.cartonnage) {
        e[rowIndex].reste = v.cartonnage - quantite;
      } else if (quantite % v.cartonnage > 0) {
        e[rowIndex].reste = v.cartonnage - (quantite % v.cartonnage);
      } else {
        e[rowIndex].reste = 0;
      }

      e[rowIndex].total = quantite ? parseInt(v.prix * quantite * (1 - remiseDecimal)).toFixed(3) : 0;

      select[rowIndex] = v;

      if ((e[rowIndex].tag == 1) && e[rowIndex].reste > 0) notify(2, "Le produit n’est recommandable que par multiple de carton");

      setProduitSelect(select);

      calculateTotalSum(e)
      setTable(e, 1);
    },
    []
  );

  // const confirmProduit = useCallback(
  //   async (entities, produitSelect, rowIndex, v) => {
  //     hideAlert()
  //     var e = [...entities];
  //     var select = [...produitSelect];
  //     e[rowIndex].index = rowIndex;
  //     e[rowIndex].idProduit = v.value;
  //     e[rowIndex].designation = v.label;
  //     e[rowIndex].code_pct = v.code_pct;
  //     e[rowIndex].code_article = v.code_article;
  //     e[rowIndex].prix = v.prix;
  //     e[rowIndex].commerce = v.commerce;
  //     e[rowIndex].total = v.commerce == 1 ? e[rowIndex].quantite > 0 ? (v.prix * e[rowIndex].quantite).toFixed(3) : 0 : 0;
  //     var reste = 0
  //     if (e[rowIndex].quantite > 0) {
  //       if (e[rowIndex].quantite < parseInt(v.cartonnage)) reste = parseInt(parseInt(v.cartonnage) - e[rowIndex].quantite)
  //       else if ((e[rowIndex].quantite % parseInt(v.cartonnage)) > 0) {
  //         reste = parseInt(parseInt(v.cartonnage) - (e[rowIndex].quantite % parseInt(v.cartonnage)))
  //       }
  //     } else {
  //       reste = null
  //     }
  //     e[rowIndex].cartonnage = v.commerce == 1 ? v.cartonnage : 0;
  //     e[rowIndex].nb = v.commerce == 1 ? v.cartonnage > 0 ? parseInt(e[rowIndex].quantite / v.cartonnage) : 0 : 0;
  //     e[rowIndex].reste = v.commerce == 1 ? reste : 0;
  //     e[rowIndex].quantite = v.commerce == 1 ? e[rowIndex].quantite : 0;
  //     select[rowIndex] = v;
  //     setProduitSelect(select);
  //     calculateTotalSum(e)
  //     setTable(e, 1);
  //   },
  //   []
  // )

  // const confirmProduitAfc = useCallback(
  //   async (entities, produitSelect, index, v) => {
  //     hideAlert()
  //     var list = [...entities];
  //     var select = [...produitSelect];

  //     list[index].index = index;
  //     list[index].idProduit = v.value;
  //     list[index].designation = v.label;
  //     list[index].code_pct = v.code_pct;
  //     list[index].code_article = v.code_article;
  //     list[index].prix = v.prix;
  //     list[index].total = v.commerce == 1 ? list[index].quantite > 0 ? (v.prix * list[index].quantite_fix).toFixed(3) : 0 : 0;
  //     list[index].cartonnage = v.commerce == 1 ? v.cartonnage : 0;
  //     list[index].nb = v.commerce == 1 ? list[index].quantite > 0 ? parseInt(list[index].quantite_fix / v.cartonnage) : 0 : 0;
  //     var reste = 0
  //     if (list[index].quantite_fix < parseInt(v.cartonnage)) reste = parseInt(parseInt(v.cartonnage) - list[index].quantite_fix)
  //     else if ((list[index].quantite_fix % parseInt(v.cartonnage)) > 0) {
  //       reste = parseInt(parseInt(v.cartonnage) - (list[index].quantite_fix % parseInt(v.cartonnage)))
  //     }
  //     list[index].quantite_fix = v.commerce == 1 ? list[index].quantite_fix : 0;
  //     list[index].quantite = v.commerce == 1 ? list[index].quantite : 0;
  //     list[index].reste = v.commerce == 1 ? reste : 0;
  //     list[index].commerce = v.commerce;
  //     select[index] = v;
  //     setProduitSelect(select);

  //     calculateTotalSum(list)
  //     setTable(list, 1)
  //   },
  //   []
  // )

  const confirmProduitAfc = useCallback(
    async (entities, produitSelect, index, v) => {
      hideAlert();
      var list = [...entities];
      var select = [...produitSelect];

      list[index].index = index;
      list[index].idProduit = v.value;
      list[index].designation = v.label;
      list[index].code_pct = v.code_pct;
      list[index].code_article = v.code_article;
      list[index].prix = v.prix;
      list[index].commerce = v.commerce;
      list[index].tag = v.tag;
      list[index].cartonnage = v.commerce === 1 ? v.cartonnage : 0;
      list[index].Remise = v.Remise;

      let quantite = parseInt(list[index].quantite) || 0;
      let quantite_fix = parseInt(list[index].quantite_fix) || 0;
      const cartonnage = parseInt(v.cartonnage);

      // 🟨 Arrondi si >= 60% de cartonnage et tag == 1
      if (v.commerce === 1 && cartonnage > 0 && quantite_fix / cartonnage >= 0.6 && v.tag == 2) {
        quantite_fix = Math.ceil(quantite_fix / cartonnage) * cartonnage;

        const seuil = cartonnage * 0.6;
        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
      }

      // 🔢 Remise
      let remiseDecimal = 0;
      if (v.Remise && v.Remise !== 0) {
        remiseDecimal = typeof v.Remise === "number" ? v.Remise : parseFloat(v.Remise);
        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
      }

      // 🔁 Calcul reste
      let reste = 0;
      if (quantite_fix < cartonnage) {
        reste = cartonnage - quantite_fix;
      } else if ((quantite_fix % cartonnage) > 0) {
        reste = cartonnage - (quantite_fix % cartonnage);
      }

      // 💾 Affectations finales
      list[index].quantite_fix = v.commerce === 1 ? quantite_fix : 0;
      list[index].quantite = v.commerce === 1 ? quantite : 0;
      list[index].reste = v.commerce === 1 ? reste : 0;
      list[index].nb = v.commerce === 1 && quantite > 0 ? parseInt(quantite_fix / cartonnage) : 0;
      list[index].total = v.commerce === 1 && quantite > 0
        ? (v.prix * quantite_fix * (1 - remiseDecimal)).toFixed(3)
        : 0;
      if ((list[index].tag == 1) && list[index].reste > 0) notify(2, "Le produit n’est recommandable que par multiple de carton");

      // ✅ Mise à jour du select
      select[index] = v;
      setProduitSelect(select);

      // 🔄 Mise à jour du tableau
      calculateTotalSum(list);
      setTable(list, 1);
    },
    []
  );


  const ListTable = ({ entities, produitSelect, resteZero, list }) => {
    return (
      <table className="table table-add table-bordered">
        <thead>
          <tr className="table-info">
            <th>{t('ID')}</th>
            <th>{t('code_pct')}</th>
            <th>{t('code_article')}</th>
            <th>{t('designation')}</th>
            <th>{t('Remise')}</th>
            <th>{t('prix')} (HT TND)</th>
            <th>{t('cartonnage')}</th>
            <th>{t("quantite_cmd")}</th>
            <th>Reste à livrer</th>
            <th>{t("quantite_rectif")}</th>
            <th>{t("nb_carton")}</th>
            <th>{t('reste')}</th>
            <th>{t('prix_total')} (HT TND)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody className="commande-import">
          {entities.map((entity, index) => (
            <tr key={index} className={entity.commerce == 0 ? "no-commerce" : entity.reste > 0 ? "reste-warning" : null}>

              <td>{entity.index + 1}</td>
              <td>{entity.tag == 1 ? <i style={{ color: "#9C27B0", fontSize: "15px" }} className="fa-solid fa-cube"></i> : null} {entity.code_pct}</td>
              <td>{entity.code_article}</td>
              <td>
                <div id="roleClass">
                  {entity.idProduit !==
                    null ? (
                    <Form.Group className="desinationProduit">
                      <Form.Control
                        className="green"
                        readOnly
                        defaultValue={
                          entity.designation
                        }
                        placeholder="Designation"
                        type="text"
                      ></Form.Control>
                      {entity.commerce == 1 ? (
                        <Button
                          variant="danger"
                          size="sm"
                          className="text-danger btn-link delete"
                          onClick={() => {
                            removeProduit(
                              entities,
                              produitSelect,
                              index
                            );
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      ) : null}
                    </Form.Group>
                  ) : (
                    <div className="table-bl">
                      {entity.designation != null ? (
                        <Form.Group className="desinationProduit">
                          <Form.Control
                            className="red"
                            readOnly
                            defaultValue={
                              entity.designation
                            }
                            placeholder="Designation"
                            type="text"
                          ></Form.Control>

                        </Form.Group>
                      ) : (
                        ""
                      )}
                      <Select
                        className="react-select primary "
                        classNamePrefix="react-select"
                        name="Produit"
                        placeholder="Produit"
                        value={produitSelect[index]}
                        onChange={(v) => {
                          confirmMessageProduit(entities, produitSelect, index, v)
                        }}
                        options={optionProduit}
                      />
                    </div>
                  )}
                </div>
              </td>
              <td>{entity.Remise}</td>
              <td>{new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              }).format(entity.prix)}</td>
              <td>{entity.cartonnage}</td>
              <td>{entity.quantite}</td>
              <td>{entity.quantite_non_soldee}</td>
              <td>
                <Form.Group>
                  <input
                    className="form-control"
                    defaultValue={entity.quantite_fix}
                    placeholder="quantite_fix"
                    type="number"
                    readOnly={entity.commerce == 1 ? false : true}
                    pattern="\d+"
                    onBlur={(value) => {
                      var e = [...entities];
                      if (e[index].commerce == 1) {

                        let rawQuantite = parseInt(value.target.value.replace(/[^0-9]/g, '')) || 0;


                        if (
                          e[index].cartonnage > 0 &&
                          rawQuantite / e[index].cartonnage >= 0.6 &&
                          e[index].tag == 2
                        ) {
                          rawQuantite = Math.ceil(rawQuantite / e[index].cartonnage) * e[index].cartonnage;

                          const seuil = e[index].cartonnage * 0.6;
                          notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
                        }


                        e[index].quantite_fix = rawQuantite;

                        e[index].nb = parseInt(e[index].quantite_fix / parseInt(e[index].cartonnage));

                        if (e[index].quantite_fix > 0 && e[index].quantite_fix < e[index].cartonnage) e[index].reste = parseInt(e[index].cartonnage - e[index].quantite_fix)
                        else if (e[index].quantite_fix > 0 && (e[index].quantite_fix % parseInt(e[index].cartonnage)) > 0) {
                          e[index].reste = parseInt(e[index].cartonnage - (e[index].quantite_fix % parseInt(e[index].cartonnage)))
                        } else if (e[index].quantite_fix == 0) {
                          e[index].reste = null
                        } else {
                          e[index].reste = 0
                        }

                        let remiseDecimal = 0;
                        if (e[index].Remise && e[index].Remise !== 0) {
                          remiseDecimal = typeof e[index].Remise === "number" ? e[index].Remise : parseFloat(e[index].Remise);
                          if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
                        }


                        if ((e[index].tag == 1) && e[index].reste > 0) {
                          e[index].quantite_fix += e[index].reste
                          rawQuantite += e[index].reste
                          e[index].nb += 1
                          e[index].reste = 0
                          notify(2, "Le produit n’est recommandable que par multiple de carton");
                        }

                        e[index].total = rawQuantite
                          ? (e[index].prix * rawQuantite * (1 - remiseDecimal)).toFixed(3)
                          : 0;

                        if (resteZero == 1) {

                          list[e[index].index].quantite_fix = rawQuantite;

                          list[e[index].index].nb = parseInt(list[e[index].index].quantite_fix / parseInt(list[e[index].index].cartonnage));

                          if (list[e[index].index].quantite_fix < list[e[index].index].cartonnage) list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - list[e[index].index].quantite_fix)
                          else if ((list[e[index].index].quantite_fix % parseInt(list[e[index].index].cartonnage)) > 0) {
                            list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - (list[e[index].index].quantite_fix % parseInt(list[e[index].index].cartonnage)))
                          } else {
                            list[e[index].index].reste = 0
                          }
                          list[e[index].index].total = (list[e[index].index].prix * parseInt(list[e[index].index].quantite_fix) * (1 - remiseDecimal)).toFixed(3)

                          calculateTotalSum(list);
                          setTable(list, 1)
                        }

                        if (resteZero == 0) { setTable(list, 1); calculateTotalSum(e); }
                        else setEntitiesReste(e)

                      }
                    }}
                  />
                </Form.Group>
              </td>
              <td>{entity.nb}</td>
              <td>{entity.reste}</td>
              <td>{new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              }).format(entity.total)}</td>
              <td>
                <Button
                  id={"idLigneR_" + index}
                  onClick={(ev) => {
                    deleteLigne(index);
                  }}
                  variant="danger"
                  size="sm"
                  className="text-danger btn-link delete"
                >
                  <i className="fa fa-trash" id={"idLigneR_" + index} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };


  const ListTable2 = ({ entities, produitSelect, resteZero, list }) => {
    return (
      <table className="table table-add table-bordered">
        <thead>
          <tr className="table-info">
            <th>{t('ID')}</th>
            <th>{t('code_pct')}</th>
            <th>{t('code_article')}</th>
            <th>{t('designation')}</th>
            <th>{t('Remise')}</th>
            <th>{t('prix')} (HT TND)</th>
            <th>{t('cartonnage')}</th>
            <th>{t("quantite_cmd")}</th>
            <th>{t('nb_carton')}</th>
            <th>{t('reste')}</th>
            <th>{t('prix_total')} (HT TND)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody className="commande-import">
          {entities.map((entity, index) => (
            <tr key={index} className={entity.commerce == 0 ? "no-commerce" : entity.reste > 0 ? "reste-warning" : null}>
              <td>{entity.index + 1}</td>
              <td>{entity.tag == 1 ? <i style={{ color: "#9C27B0", fontSize: "15px" }} className="fa-solid fa-cube"></i> : null} {entity.code_pct}</td>
              <td>{entity.code_article}</td>
              <td>
                <div id="roleClass">
                  {entity.idProduit !==
                    null ? (
                    <Form.Group className="desinationProduit">
                      <Form.Control
                        className="green"
                        readOnly
                        defaultValue={
                          entity.designation
                        }
                        placeholder="Designation"
                        type="text"
                      ></Form.Control>
                      {entity.commerce == 1 ? (
                        <Button
                          variant="danger"
                          size="sm"
                          className="text-danger btn-link delete"
                          onClick={() => {
                            removeProduit(
                              entities,
                              produitSelect,
                              index
                            );
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      ) : null}
                    </Form.Group>
                  ) : (
                    <div className="table-bl">
                      {entity.designation != null ? (
                        <Form.Group className="desinationProduit">
                          <Form.Control
                            className="red"
                            readOnly
                            defaultValue={
                              entity.designation
                            }
                            placeholder="Designation"
                            type="text"
                          ></Form.Control>

                        </Form.Group>
                      ) : (
                        ""
                      )}
                      <Select
                        className="react-select primary "
                        classNamePrefix="react-select"
                        name="Produit"
                        placeholder="Produit"
                        value={produitSelect[index]}
                        onChange={(v) => {
                          confirmMessageProduit(entities, produitSelect, index, v)
                          // var list = [...entities];
                          // var select = [...produitSelect];
                          // list[index].idProduit = v.value;
                          // list[index].designation = v.label;
                          // list[index].code_pct = v.code_pct;
                          // list[index].code_article = v.code_article;
                          // list[index].prix = v.prix;
                          // list[index].total = v.commerce == 1 ? (v.prix * list[index].quantite_fix).toFixed(3) : 0;
                          // list[index].cartonnage = v.commerce == 1 ? v.cartonnage : 0;
                          // list[index].commerce = v.commerce;
                          // list[index].nb = v.commerce == 1 ? parseInt(list[index].quantite_fix / v.cartonnage) : 0;
                          // var reste = 0
                          // if (list[index].quantite_fix < parseInt(v.cartonnage)) reste = parseInt(parseInt(v.cartonnage) - list[index].quantite_fix)
                          // else if ((list[index].quantite_fix % parseInt(v.cartonnage)) > 0) {
                          //   reste = parseInt(parseInt(v.cartonnage) - (list[index].quantite_fix % parseInt(v.cartonnage)))
                          // }
                          // list[index].quantite_fix = v.commerce == 1 ? list[index].quantite_fix : 0;
                          // list[index].quantite = v.commerce == 1 ? list[index].quantite : 0;
                          // list[index].reste = v.commerce == 1 ? reste : 0;
                          // select[index] = v;
                          // setProduitSelect(select);
                          // setTable(list, 1)
                        }}
                        options={optionProduit}
                      />
                    </div>
                  )}
                </div>
              </td>
              <td>{entity.Remise}</td>
              <td>{new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              }).format(entity.prix)}</td>
              <td>{entity.cartonnage}</td>
              <td>
                <Form.Group>
                  <input
                    className="form-control"
                    defaultValue={entity.quantite}
                    placeholder="quantite"
                    type="number"
                    pattern="\d+"
                    readOnly={entity.commerce == 1 ? false : true}
                    onBlur={(value) => {
                      var e = [...entities];

                      let rawQuantite = parseInt(value.target.value.replace(/[^0-9]/g, '')) || 0;


                      if (
                        e[index].cartonnage > 0 &&
                        rawQuantite / e[index].cartonnage >= 0.6 &&
                        e[index].tag == 2
                      ) {
                        rawQuantite = Math.ceil(rawQuantite / e[index].cartonnage) * e[index].cartonnage;
                        const seuil = e[index].cartonnage * 0.6;
                        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
                      }




                      e[index].quantite_fix = rawQuantite;
                      e[index].quantite = rawQuantite;

                      e[index].nb = parseInt(e[index].quantite_fix / parseInt(e[index].cartonnage));

                      if (e[index].quantite_fix > 0 && e[index].quantite_fix < e[index].cartonnage) e[index].reste = parseInt(e[index].cartonnage - e[index].quantite_fix)
                      else if (e[index].quantite_fix > 0 && (e[index].quantite_fix % parseInt(e[index].cartonnage)) > 0) {
                        e[index].reste = parseInt(e[index].cartonnage - (e[index].quantite_fix % parseInt(e[index].cartonnage)))
                      } else if (e[index].quantite_fix == 0) {
                        e[index].reste = null
                      } else {
                        e[index].reste = 0
                      }

                      if ((e[index].tag == 1) && e[index].reste > 0) notify(2, "Le produit n’est recommandable que par multiple de carton");

                      let remiseDecimal = 0;
                      if (e[index].Remise && e[index].Remise !== 0) {
                        remiseDecimal = typeof e[index].Remise === "number" ? e[index].Remise : parseFloat(e[index].Remise);
                        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
                      }

                      e[index].total = rawQuantite
                        ? (e[index].prix * rawQuantite * (1 - remiseDecimal)).toFixed(3)
                        : 0;

                      console.log(e[index].total)
                      if (resteZero == 1) {

                        list[e[index].index].quantite = rawQuantite;
                        list[e[index].index].quantite_fix = rawQuantite;

                        list[e[index].index].nb = parseInt(list[e[index].index].quantite_fix / parseInt(list[e[index].index].cartonnage));

                        if (list[e[index].index].quantite_fix < list[e[index].index].cartonnage) list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - list[e[index].index].quantite_fix)
                        else if ((list[e[index].index].quantite_fix % parseInt(list[e[index].index].cartonnage)) > 0) {
                          list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - (list[e[index].index].quantite_fix % parseInt(list[e[index].index].cartonnage)))
                        } else {
                          list[e[index].index].reste = 0
                        }
                        list[e[index].index].total = (list[e[index].index].prix * parseInt(list[e[index].index].quantite_fix) * (1 - remiseDecimal)).toFixed(3)

                        calculateTotalSum(list);
                        setTable(list, 1)
                      }

                      if (resteZero == 0) { setTable(list, 1); calculateTotalSum(e); }
                      else setEntitiesReste(e)

                    }

                    }
                  />
                </Form.Group>
              </td>
              <td>{entity.nb}</td>
              <td>{entity.reste}</td>
              <td>{new Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3
              }).format(entity.total)}</td>
              <td>
                <Button
                  id={"idLigneR_" + index}
                  onClick={(ev) => {
                    deleteLigne(index);
                  }}
                  variant="danger"
                  size="sm"
                  className="text-danger btn-link delete"
                >
                  <i className="fa fa-trash" id={"idLigneR_" + index} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };


  function getProduitReste(list, resteZero) {
    const filteredList = list.filter(item => {
      if (resteZero === 1) {
        if (item.idProduit != null) return item.reste != 0 && item.reste != null;
      } else {
        return true;
      }
    });
    setEntitiesReste(filteredList)
  }

  const calculateTotalSum = (entities) => {
    var e = [...entities]
    const sum = e.reduce((acc, curr) => {
      return acc + parseFloat(curr.total || 0); // add total to accumulator, default to 0 if total is undefined
    }, 0); // initial accumulator value is 0
    setTotal(sum);
  };
  useEffect(() => {

    const fetchData = async () => {
      await verifToken();
      if (idRole.current > 0) {
        getFileCmdFromDB(idCmd);
        detailCmd(idCmd)
        if (obj.user.id_role == 6) getproduit()
        else getproduitAfc(client)
      }
    };

    fetchData();

  }, [getFileCmdFromDB, idCmd, id]);



  return (
    <>
      {alert}
      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        ""
      )}
      {!loader ? (
        <Container fluid>
          <ToastContainer />
          <div className="section-image">
            <Row>
              <Col md="12">
                <Button
                  id="saveBL"
                  className="btn-wd btn-outline mr-1 float-left"
                  type="button"
                  variant="info"
                  onClick={() => {
                    window.history.back();
                  }}
                >
                  <span className="btn-label">
                    <i className="fas fa-list"></i>
                  </span>
                  {t('list')}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Header>
                      <Card.Title as="h4">{t("order_update")}</Card.Title>
                    </Card.Header>
                    <Card.Body>

                      {fileName != "null" ? <div className="pdf-vs">
                        {ext === "pdf" ? (
                          <div className="visualiser">
                            <iframe
                              title="Transition"
                              width="100%"
                              height="500px"
                              src={`${fileURL}#toolbar=0`}
                            /* src={fileURL} */
                            ></iframe>
                            <br></br>
                            <a
                              className="btn btn-info"
                              download={fileName}
                              rel="noreferrer"
                              href={Configuration.BACK_BASEURL + "commande/" + fileName}
                              target="_blank"
                            >
                              <i className="fas fa-download"></i> {t("download")}
                            </a>
                          </div>
                        ) : (
                          <div className="visualiser">
                            <img
                              src={fileURL}
                              className="img-file"
                              alt=""
                            ></img>
                            <br></br>
                            <a
                              download={fileName}
                              rel="noreferrer"
                              href={Configuration.BACK_BASEURL + "commande/" + fileName}
                              target="_blank"
                              className="btn btn-info"
                            >
                              <i className="fas fa-download"></i> {t("download")}
                            </a>
                          </div>
                        )}

                      </div> : null}

                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>{t("num_order")}</th>
                              <th>Code Grossiste</th>
                              <th>Grossiste</th>
                              <th>Date {t("commande")}</th>
                              <th>{t("date_liv_souhaite")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{cmd.numero}</td>
                              <td>{cmd.grossistes ? cmd.Code_client : " "}</td>
                              <td>{cmd.grossistes ? cmd.grossistes.Raison_sociale : " "}</td>
                              <td>{cmd.date_commande}</td>
                              <td>{cmd.date_livraison}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr>
                        <h4 className="float-left"><strong>{t('montant_total')} : {new Intl.NumberFormat('fr-FR', {
                          minimumFractionDigits: 3,
                          maximumFractionDigits: 3
                        }).format(total)} HT TND</strong></h4>

                        <Row className="float-right" style={{ width: "50%", margin: "30px 0 15px" }}>
                          <Col md="12">
                            <Row>
                              <Col md="6">
                                <Form.Group>
                                  <Form.Check>
                                    <Form.Check.Label>
                                      <Form.Check.Input
                                        type="checkbox"
                                        checked={resteZero == 1 ? true : false}
                                        onChange={(v) => {
                                          if (v.target.checked) {
                                            setResteZero(1);
                                            getProduitReste(data, 1)
                                          }
                                          else setResteZero(0)
                                        }}
                                      ></Form.Check.Input>
                                      <span className="form-check-sign"></span>
                                      <label>{t('produit_en_vrac')}</label>
                                    </Form.Check.Label>
                                  </Form.Check>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <br></br><br></br>
                        {idRole.current == 5 || idRole.current == 10 ?
                          <>
                            <ListTable entities={resteZero == 0 ? data : entitiesReste} list={data} produitSelect={produitSelect} resteZero={resteZero} />
                          </>
                          :

                          <ListTable2 entities={resteZero == 0 ? data : entitiesReste} list={data} produitSelect={produitSelect} resteZero={resteZero} />
                        }
                        <hr></hr>
                        {!save && idRole.current == 6 && resteZero == 0 ? <Button
                          className="btn-wd btn-outline mr-1 float-left"
                          type="button"
                          variant="info"
                          nom="redac"
                          onClick={(ev) => AjoutLigne()}
                        >
                          {t("add_product")}
                        </Button> : ""}
                      </div>
                      {!save ?
                        <Button
                          className="btn-fill pull-right"
                          type="button"
                          variant="info"
                          onClick={() => saveTable(data, idCmd, total)}
                        >
                          {t("save_draft")}
                        </Button>
                        : ""}
                      <div className="clearfix"></div>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      ) : (
        ""
      )}
    </>
  );
}

export default UpdateCmd;
